const article = {
    slug: "first_junya_watanabe_experience",
    category: "BRAND ENTRY",
    title: "初めてのJUNYA WATANABEをレンタル体験",
    listDescription:
      "パッチワーク、再構築、デニム、コラボレーション。JUNYA WATANABEを“着ること”から理解する入口ページ。",
    seo: {
      title:
        "初めてのジュンヤワタナベをレンタル体験｜JUNYA WATANABEを着て知るEnclopedia",
      description:
        "JUNYA WATANABEが気になるけれど、どんなブランドか分からない方へ。ジュンヤワタナベの魅力、JUNYA WATANABE MAN、eYe、パッチワーク、再構築、デニム、コラボレーションの見方を分かりやすく解説し、Enclopediaでレンタルできるアーカイブへ案内します。",
      keyword:
        "初めてのジュンヤワタナベ,ジュンヤワタナベ 初めて,JUNYA WATANABE 初めて,ジュンヤワタナベ とは,JUNYA WATANABE どんなブランド,ジュンヤワタナベ レンタル,JUNYA WATANABE レンタル,ジュンヤワタナベマン レンタル,JUNYA WATANABE MAN レンタル,eYe JUNYA WATANABE MAN,ジュンヤワタナベ アーカイブ,JUNYA WATANABE アーカイブ,ジュンヤワタナベ コラボ,ジュンヤワタナベ パッチワーク,ジュンヤワタナベ デニム,enclopedia,アンクロペディア",
      canonicalPath: "/archive_guide/first_junya_watanabe_experience",
    },
    hero: {
      label: "FIRST JUNYA WATANABE EXPERIENCE",
      number: "05 / ENTRY",
      titleLines: ["初めての", "JUNYA WATANABEをレンタル体験。"],
      body:
        "JUNYA WATANABEは、\n見慣れた服をそのまま扱うのではなく、\n素材、パターン、機能、コラボレーションを通して別の服へ編集するブランドです。\n初めて知るなら、まずは“着ることで分かる構造の面白さ”から入るのが自然です。",
      keywords: [
        "first experience",
        "reconstruction",
        "patchwork",
        "junya watanabe",
      ],
      visualLabel: "ARCHIVE EXPERIENCE",
      visualTitle: ["服を作るのではなく、", "服の構造を編集する。"],
      image: "media/archive_fashion/archive_guide5.png",
      imageAlt:
        "初めてのJUNYA WATANABEをレンタル体験するためのアーカイブガイド画像",
      ctaLabel: "レンタルできるJUNYA WATANABEを見る",
      ctaHref:
        "https://www.enclopedia-official.com/brand/JUNYA%20WATANABE（ジュンヤワタナベ）/?number=32",
    },
    thesis: {
      text:
        "JUNYA WATANABEは、既存の服や素材を再編集することで、日常着の可能性を拡張するブランドです。",
      keywords: ["reconstruction", "collaboration", "experience"],
    },
    sections: {
      whyThisPage: {
        label: "02 / WHY THIS PAGE?",
        titleLines: [
          "JUNYA WATANABEが気になる。",
          "でも、どこから見ればいいか分からない。",
        ],
        body:
          "JUNYA WATANABEは、ファッション好きには強く評価される一方で、初めて見る人には“コラボが多いブランド”や“デザインが複雑なブランド”として見えることがあります。\nしかし本質は、単なる装飾や話題性ではありません。\nデニム、ワークウェア、ミリタリー、テーラード、スポーツウェアなど、すでに存在する服の構造を読み替え、別の表情へ変えるところに面白さがあります。",
      },
  
      brandOverview: {
        label: "03 / BRAND OVERVIEW",
        titleLines: [
          "服をゼロから作るのではなく、",
          "既存の服をもう一度読み替える。",
        ],
        body:
          "JUNYA WATANABEは、渡辺淳弥が手がけるブランドです。\nウィメンズのJUNYA WATANABE、メンズのJUNYA WATANABE MAN、より実用性と協業性が強く出るeYe JUNYA WATANABE MANなど、複数の入口があります。\n共通しているのは、既存の服の形、素材、機能を尊重しながら、それをそのまま終わらせないこと。パッチワーク、再構築、異素材の接続、コラボレーションを通じて、服の見え方を変えていきます。",
        knowledgeItems: [
          {
            title: "パッチワークは、装飾ではなく構造の編集。",
            text:
              "異なる布やパーツを組み合わせることで、服の表面だけでなく、成り立ちそのものを見せる。JUNYA WATANABEの代表的な読み方です。",
          },
          {
            title: "コラボレーションは、ロゴ交換ではない。",
            text:
              "Levi’s、THE NORTH FACE、Brooks Brothersなど、相手ブランドの持つ“本物の服”をどう再解釈するかが重要になります。",
          },
          {
            title: "デニムやワークウェアが、実験の土台になる。",
            text:
              "日常的で機能的な服を起点にするからこそ、再構築されたときの違いが分かりやすく立ち上がります。",
          },
          {
            title: "アーカイブで見ると、編集の蓄積が分かる。",
            text:
              "過去のシーズンを追うと、パターン、素材、コラボレーション、身体との距離がどのように変化してきたかが見えてきます。",
          },
        ],
      },
  
      lineGuide: {
        label: "04 / HOW TO SEE JUNYA?",
        titleLines: [
          "JUNYA WATANABEを見るなら、",
          "まず4つの視点から。",
        ],
        items: [
          {
            tag: "ENTRY 01",
            title: "RECONSTRUCTION",
            text:
              "既存の服を分解し、別のバランスで組み直す。JUNYA WATANABEを理解する最も基本的な視点です。",
          },
          {
            tag: "ENTRY 02",
            title: "PATCHWORK & MATERIAL",
            text:
              "デニム、チェック、ツイード、ナイロンなど、異なる素材を接続することで服に新しい構造を与えます。",
          },
          {
            tag: "ENTRY 03",
            title: "MAN / eYe",
            text:
              "JUNYA WATANABE MANやeYeでは、ワーク、ミリタリー、アウトドア、スポーツウェアの要素が強く現れます。",
          },
          {
            tag: "ENTRY 04",
            title: "COLLABORATION",
            text:
              "コラボレーションは話題性だけでなく、相手ブランドの服をJUNYAの設計思想へ翻訳する試みとして見られます。",
          },
        ],
      },
  
      firstExperience: {
        label: "05 / FIRST EXPERIENCE",
        titleLines: ["初めて着ると、", "何が分かるのか。"],
        intro:
          "JUNYA WATANABEの服は、写真で見るよりも、身体に乗せたときに“なぜこの構造なのか”が分かりやすくなるブランドです。",
        items: [
          {
            index: "01",
            title: "見慣れた服が、少し違う服に変わる",
            text:
              "ジャケット、デニム、ブルゾン、シャツ。知っている服の形を残しながら、切替や素材の接続によって別の存在感を持たせます。",
          },
          {
            index: "02",
            title: "素材のつながり方で、服の見え方が変わる",
            text:
              "パッチワークや異素材の切替は、表面的な装飾ではありません。服の重さ、動き、立体感を変える構造として働きます。",
          },
          {
            index: "03",
            title: "コラボレーションの意味が見えてくる",
            text:
              "相手ブランドの機能や歴史を残しながら、JUNYA WATANABEのパターンや編集で別の服へ変える。その変化は着ると理解しやすくなります。",
          },
        ],
      },
  
      quote: {
        textLines: [
          "既にある服を、",
          "もう一度発明する。",
        ],
      },
  
      whyRent: {
        label: "06 / WHY RENT?",
        titleLines: [
          "初めてのJUNYA WATANABEほど、",
          "レンタルで理解が深まる。",
        ],
        items: [
          {
            number: "01",
            title: "写真では、構造の厚みが読み切れない",
            text:
              "パッチワーク、切替、異素材の重なりは、写真だけでは分かりにくい部分があります。実物では、素材の厚みや立体感まで確認できます。",
          },
          {
            number: "02",
            title: "日常着との距離を確かめられる",
            text:
              "JUNYA WATANABEは、ワークウェアやデニムなど身近な服を土台にしているため、強いデザインでも日常に入る場合があります。",
          },
          {
            number: "03",
            title: "購入前に、コラボやアーカイブの価値を体験できる",
            text:
              "高額なコラボレーションや希少なアーカイブほど、見た目だけでなく、着たときの納得感を確かめる意味があります。",
          },
        ],
      },
  
      inventory: {
        label: "07 / AVAILABLE ARCHIVE",
        titleLines: ["Enclopediaで", "体験できるJUNYA WATANABE。"],
        body:
          "実在庫への導線は、“JUNYA WATANABEを知る続き”として設計します。まず背景を理解し、次に実物で確かめる流れを作ります。",
        items: [
          {
            meta: "JUNYA WATANABE MAN × FILSON / 2025-2026AW",
            title: "マッキーノ・クルーザージャケット",
            text:
              "クラシックなワークウェアを土台に、縮絨加工やポケット配置の編集で、定番服の見え方をずらした一着。",
            href:
              "https://www.enclopedia-official.com/product/448054dc-1314-4896-a70c-a0e1884fa137",
            image:
              "media/product/1775380069.160123448054dc-1314-4896-a70c-a0e1884fa137.png"
          },
          {
            meta: "JUNYA WATANABE MAN / 2025SS Dress up denim",
            title: "パッチワークテーラードジャケット",
            text:
              "デニムや異素材のパッチワークをさらに押し広げ、テーラードの端正さにパンクな編集感を重ねた2025SSらしい一着。",
            href:
              "https://www.enclopedia-official.com/product/d6b727ef-ac18-43d9-8323-0b8afc855db7",
            image:
              "media/product/1777819179.8824942d6b727ef-ac18-43d9-8323-0b8afc855db7.png"
          },
        ],
      },
  
      faq: {
        label: "08 / FAQ",
        titleLines: ["初めての人が、", "気になりやすいこと。"],
        items: [
          {
            question: "JUNYA WATANABEは、どんなブランドですか？",
            answer:
              "既存の服や素材を再編集し、パッチワーク、再構築、異素材切替、コラボレーションを通じて新しい服の見え方を作るブランドです。",
          },
          {
            question: "JUNYA WATANABEとJUNYA WATANABE MANは違いますか？",
            answer:
              "はい。JUNYA WATANABEはウィメンズを中心としたラインで、JUNYA WATANABE MANはメンズラインです。MANではワーク、ミリタリー、デニム、アウトドア、コラボレーションの文脈が強く出ます。",
          },
          {
            question: "初めてなら、どのアイテムから見るのがおすすめですか？",
            answer:
              "ジャケット、デニム、ブルゾン、シャツなど、日常着の形式を残しながら構造の違いが分かるアイテムがおすすめです。",
          },
          {
            question: "コラボレーションアイテムは初心者にも分かりやすいですか？",
            answer:
              "分かりやすいです。相手ブランドの定番服をJUNYA WATANABEがどう再編集しているかを見ると、ブランドの特徴を理解しやすくなります。",
          },
          {
            question: "レンタル後に購入もできますか？",
            answer:
              "対象アイテムは、レンタル体験を経たうえで購入相談へ進める導線を想定しています。",
          },
        ],
      },
  
      finalCta: {
        titleLines: [
          "初めてのJUNYA WATANABEを、",
          "レンタルから始める。",
        ],
        body:
          "既にある服が、構造と編集によって別の表情を持つ。\nEnclopediaで、JUNYA WATANABEのアーカイブを体験してください。",
        buttonLabel: "レンタルできるJUNYA WATANABEを見る",
        buttonHref:
          "https://www.enclopedia-official.com/brand/JUNYA%20WATANABE（ジュンヤワタナベ）/?number=32",
      },
    },
  };

export default article;
